import "antd/lib/form/style";
import _Form from "antd/lib/form";
import { connect } from 'dva';
import BI0802 from '../../components/BI/BI0802/index';
function mapDispatchToProps(_ref) {
  var bi0802Info = _ref.bi0802Info;
  return {
    bi0802Info: bi0802Info
  };
}
var BI0802R = _Form.create()(BI0802);
export default connect(mapDispatchToProps)(BI0802R);